define("analytics-resources/utils/math/find-min-and-max", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const calculateMinAndMax = data => {
    const nonNullData = data.filter(value => value[1] !== null);
    const lowestPoint = Math.min(...nonNullData.map(item => item[1]));
    const highestPoint = Math.max(...nonNullData.map(item => item[1]));
    const diff = highestPoint - lowestPoint;
    let min = Math.floor(lowestPoint - diff * 0.1);
    let max = Math.ceil(highestPoint);
    if (min <= 0) {
      min = 0;
    }
    if (max === 0) {
      max = 1;
    }
    return {
      min,
      max
    };
  };
  var _default = _exports.default = calculateMinAndMax;
});